// SuperAdminHome.js
import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from "../UserContext";
import Header from '../Header';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers, 
  FaWallet, 
  FaChevronRight, 
  FaUserPlus,
} from 'react-icons/fa';
import AnnouncementModal from '../AnnouncementModal';
import QRCodeModal from "../QRCodeModal";

const OperatorHome = () => {
  const { token, user } = useContext(UserContext);
  const navigate = useNavigate();

  const [dashboardData, setDashboardData] = useState({
    totalCustomers: 0,
    totalWallet: 0,
  });

  const [loading, setLoading] = useState(true);
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);

  const openQRCodeModal = () => setShowQRModal(true);
  const closeQRCodeModal = () => setShowQRModal(false);

  // Check if modal should be shown on component mount
  useEffect(() => {
    // Create a unique key for this user's login session
    const announcementKey = `announcementShown_${user?.operatorId}`;
    
    // Check if we've already shown the announcement for this login session
    const announcementShown = localStorage.getItem(announcementKey);
    
    if (!announcementShown) {
      setShowAnnouncement(true);
      // Mark that we've shown the announcement for this login session
      localStorage.setItem(announcementKey, 'true');
    }
    
  }, [user]);

  const fetchDashboard = async () => {
    try {
      const res = await fetch('https://vrplay.in/portal_php/dashboard/operator_dashboard.php', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      
      setDashboardData(data);
      setLoading(false);
    } catch (err) {
      // console.error('Failed to fetch dashboard:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  // Format number with commas
  const formatNumber = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleCloseAnnouncement = () => {
    setShowAnnouncement(false);
  };

  return (
    <>
      <Header />
      <div className="superadmin-dashboard">

        {showAnnouncement && (
          <AnnouncementModal onClose={handleCloseAnnouncement} />
        )}

        {showQRModal && (
          <QRCodeModal
            operatorId={user?.operatorId}
            operatorName={user?.name || "Operator"}
            onClose={closeQRCodeModal}
          />
        )}
        
        <div className="app-link alt-purple">
          <div className='dash-add-amount'>
            <h1>Dashboard: </h1>
              <div className="action-buttons">
              <button onClick={openQRCodeModal} className='add-money'>₹ Add Money</button>
              {(user?.createdBy === 1 || user?.createdBy === "1") ? (
                <button onClick={() => window.open("upi://pay?pa=sdtechnologies1@ybl&pn=SD%20Technologies&cu=INR", "_blank")} className='add-money'>
                  Pay via UPI
                </button>
              ) : ("")}
              </div>
          </div>
          {(user?.createdBy === 1 || user?.createdBy === "1") ? (
            <p><span className='app-head'>Please share payment details to:</span> 9703388253 or 9125253535</p>
          ) : ("")}
        </div>
        
        {loading ? (
          <div className="dashboard-loading">
            <div className="loader"></div>
            <p>Loading dashboard data...</p>
          </div>
        ) : (
          <>
            <div className="dashboard-cards">
              
              <div className="card customer-card" onClick={() => {navigate('/customers')}}>
                <div className="card-icon">
                  <FaUsers />
                </div>
                <div className="card-content">
                  <h2>{formatNumber(dashboardData.totalCustomers)}</h2>
                  <p>Customers</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
              
              <div className="card wallet-card" onClick={() => {navigate('/wallet-history')}}>
                <div className="card-icon">
                  <FaWallet />
                </div>
                <div className="card-content">
                  <h2>₹{formatNumber(dashboardData.totalWallet)}</h2>
                  <p>Total Wallet</p>
                </div>
                <div className="card-arrow">
                  <FaChevronRight />
                </div>
              </div>
            </div>
            
            <div className='quick-actions'>
              <h3>Quick Actions</h3>
              <div className="action-buttons">
                <button className="action-btn customer-btn" onClick={() => navigate('/add-customer')}>
                  <FaUserPlus />
                  <span>Add Customer</span>
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OperatorHome;